export const ACTION_HISTORY_LOG_TYPE = 0
export const ACTION_COMMENT_LOG_TYPE = 1
